import { ROUTES } from "consts";

// The legacy Giant Tires requests screen is being retired and its backing
// stored procedures are removed, so it must not be offered from the menu
// anymore. The route stays registered so existing bookmarks and in-flight
// links still resolve instead of 404-ing.
export const MENU_HIDDEN_PATHS: string[] = [ROUTES.requests];

export const getMenuRoutes = <T extends { path: string }>(routes: T[]): T[] =>
  routes.filter(({ path }) => !MENU_HIDDEN_PATHS.includes(path));
